
<mat-chip-grid #chipGrid aria-label="inputPlaceholder">
    @for (email of enteredEmails; track $index) {
        <mat-chip-row (removed)="remove(email)">
            {{email}}
          <button matChipRemove [attr.aria-label]="'remove ' + email">
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
    }
</mat-chip-grid>
    
<input
        matInput
        #emailComponentInput
        [formControl]="emailFormControl"
        [placeholder]="inputPlaceholder"
        [matAutocomplete]="auto"
        [matChipInputFor]="chipGrid"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (matChipInputTokenEnd)="onInputTokenEnd($event)"
        (blur)="onBlur()"
        (focus)="onFocus()"
        />

<mat-autocomplete (optionSelected)="onOptionSelected($event)" #auto="matAutocomplete">
    @for (email of filteredEmails$ | async; track email) {
        <mat-option [value]="email">{{email}}</mat-option>
    }
</mat-autocomplete>

